var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.location}},[_vm._t("default",function(){return [_vm._v("get in touch")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }